import { CUSTOM_FIELD_TYPE } from "model/entities/Workflow";

export const isFieldWithOptions = (type: CUSTOM_FIELD_TYPE) => {
  return (
    type === CUSTOM_FIELD_TYPE.SINGLE_CHOICE ||
    type === CUSTOM_FIELD_TYPE.MULTIPLE_CHOICE ||
    isBooleanField(type)
  );
};

export const isBooleanField = (type: CUSTOM_FIELD_TYPE) => {
  return type == CUSTOM_FIELD_TYPE.BOOLEAN;
};

export const isMxolField = (type: CUSTOM_FIELD_TYPE) => {
  return type === CUSTOM_FIELD_TYPE.MATRIX_ON_LIST;
};

export const isScolOrMcolField = (type: CUSTOM_FIELD_TYPE) => {
  return (
    type === CUSTOM_FIELD_TYPE.SINGLE_CHOICE_ON_LIST ||
    type === CUSTOM_FIELD_TYPE.MULTIPLE_CHOICE_ON_LIST
  );
};

export const isPictureField = (type: CUSTOM_FIELD_TYPE) => {
  return type === CUSTOM_FIELD_TYPE.PICTURE;
};
